<template>
  <div class="footer-global-6dc30">
    <div class="footer-global-6dc30__top-section">
      <!-- Company into section -->
      <div class="company-info-section-2f754 footer-global-6dc30__company-info-section">
        <RouterLink lang="en" hreflang="en" :to="{ name: 'Home' }">
          <img class="company-info-section-2f754__logo" src="https://cdn.shrpa.com/images/shrpa-full-color.png" alt="Shrpa" />
        </RouterLink>

        <div class="company-info-section-2f754__description">End-to-End UGC Solutions for Every Destination</div>

        <ul class="company-info-section-2f754__social-icons-row">
          <li class="company-info-section-2f754__social-icon">
            <a href="https://instagram.com/tryshrpa/" target="_blank" style="font: 1px/1px sans-serif"><IconEmbedded name="instagram" :size="23" /></a>
          </li>
          <li class="company-info-section-2f754__social-icon">
            <a href="https://facebook.com/tryshrpa" target="_blank" style="font: 1px/1px sans-serif"><IconEmbedded name="facebook" :size="23" /></a>
          </li>
          <li class="company-info-section-2f754__social-icon">
            <a href="https://www.linkedin.com/company/tryshrpa/" target="_blank" style="font: 1px/1px sans-serif"><IconEmbedded name="linkedin" :size="26" /></a>
          </li>
        </ul>
        <!-- / Company into section -->
      </div>

      <div class="footer-global-6dc30__link-columns-row" style="align-items: center">
        <!-- Links column -->
        <div class="links-column-470a7 footer-global-6dc30__links-column footer-global-6dc30__links-column--1">
          <h4 class="global-h4 links-column-470a7__title">Solutions</h4>

          <div class="links-column-470a7__links-list">
            <RouterLink lang="en" hreflang="en" :to="{ name: 'Home' }" class="links-column-470a7__link">For Destinations</RouterLink>
            <a class="links-column-470a7__link" href="https://explore.shrpa.com/become-a-creator-today/">For Creators</a>
            <RouterLink lang="en" hreflang="en" :to="{ name: 'Contact' }" class="links-column-470a7__link">Contact</RouterLink>
          </div>
        </div>
        <!-- / Links column -->

        <!--&lt;!&ndash; Links column &ndash;&gt;-->
        <!--<div class="links-column-470a7 footer-global-6dc30__links-column footer-global-6dc30__links-column&#45;&#45;3">-->
        <!--  <h4 class="global-h4 links-column-470a7__title">Resources</h4>-->

        <!--  <ul class="links-column-470a7__links-list">-->
        <!--    <li class="links-column-470a7__link">Blog</li>-->
        <!--    <li class="links-column-470a7__link">Glossary</li>-->
        <!--    <li class="links-column-470a7__link">Events</li>-->
        <!--  </ul>-->
        <!--</div>-->
        <!--&lt;!&ndash; / Links column &ndash;&gt;-->

        <!--&lt;!&ndash; Links column &ndash;&gt;-->
        <!--<div class="links-column-470a7 footer-global-6dc30__links-column footer-global-6dc30__links-column&#45;&#45;2">-->
        <!--  <h4 class="global-h4 links-column-470a7__title">Platform</h4>-->

        <!--  <ul class="links-column-470a7__links-list">-->
        <!--    <li class="links-column-470a7__link">User-Generated Content</li>-->
        <!--    <li class="links-column-470a7__link">Digital Asset Manager</li>-->
        <!--    <li class="links-column-470a7__link">Sharing Content</li>-->
        <!--    <li class="links-column-470a7__link">Member Management</li>-->
        <!--    <li class="links-column-470a7__link">Pricing</li>-->
        <!--  </ul>-->
        <!--</div>-->
        <!--&lt;!&ndash; / Links column &ndash;&gt;-->
      </div>
    </div>

    <div class="footer-global-6dc30__bottom-section">
      <div class="footer-global-6dc30__copyright-text">
        &copy; 2025 shrpa.com. <RouterLink lang="en" hreflang="en" :to="{ name: 'Terms' }" class="footer-global-6dc30__copyright-link">Terms</RouterLink> &
        <RouterLink lang="en" hreflang="en" :to="{ name: 'Privacy' }" class="footer-global-6dc30__copyright-link">Privacy</RouterLink>
      </div>

      <div class="footer-global-6dc30__additional-links-row">
        <!--<div class="footer-global-6dc30__additional-link">DCMA Policy</div>-->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount } from "vue";

// Components
import IconEmbedded from "@components/ui/IconEmbedded.vue";

// CSS
onBeforeMount(async () => await import("./FooterGlobal.vue.scss"));
</script>
